import { Link } from 'react-router-dom';

const Row = ({ featureToggle, onEnable }:any) => {

    return (    
        <>
            <tr>
                <td><Link to={`/admin/feature-toggles/${featureToggle.id}`}>{featureToggle.name}</Link></td>
                <td>{featureToggle.enabled ? "Yes": "No"}</td>                
            </tr>           
        </>        
    )    
};

export default Row;